import { FC } from "react";
import {
  CompanyLogoWrapper,
  CompanyLogoImage,
  CompanyLogoText,
} from "./styled";

interface CompanyLogoProps {
  company: any;
}

const CompanyLogo: FC<CompanyLogoProps> = ({ company }) => {
  if (company.logo) {
    return (
      <CompanyLogoWrapper>
        <CompanyLogoImage src={company.logo} alt={company.name} />
      </CompanyLogoWrapper>
    );
  } else {
    const textSubCompany = company.name?.slice(0, 2) || "";
    return (
      <CompanyLogoWrapper>
        <CompanyLogoText>{textSubCompany}</CompanyLogoText>
      </CompanyLogoWrapper>
    );
  }
};

export default CompanyLogo;
